var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueDiamond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.12853 2.23438L4.93242 5.3334L6.99844 11.7659M6.99844 11.7659L9.11882 5.27904L7.97708 2.23438M6.99844 11.7659L1.39844 5.38777M6.99844 11.7659L12.5984 5.38777M1.39844 5.38777L3.79067 2.23438H10.2606L12.5984 5.38777M1.39844 5.38777H12.5984",
    stroke: "#40D2FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueDiamond);
export default __webpack_public_path__ + "static/media/blueDiamond.364dffbd4c22077019495feea8dc6ba4.svg";
export { ForwardRef as ReactComponent };